import React from 'react';
import './MagicBehindMoments.css';

interface ProcessStep {
  stepNumber: number;
  title: string;
  description: string;
  illustration: string;
}

const processSteps: ProcessStep[] = [
  {
    stepNumber: 1,
    title: "Welcome Your Memory Keeper",
    description: "Your personal storyteller arrives at your home, ready for a quick and simple 5-minute self-setup.",
    illustration: "https://pratham-public-bucket.s3.us-east-1.amazonaws.com/1755564289211~2.jpg"
  },
  {
    stepNumber: 2,
    title: "Live, Laugh, and Play", 
    description: "As you enjoy your family time, your Memory Keeper quietly captures the candid, beautiful moments from a safe and respectful distance.",
    illustration: "https://pratham-public-bucket.s3.us-east-1.amazonaws.com/1755564172799~2.jpg"
  },
  {
    stepNumber: 3,
    title: "Relive the Wonder",
    description: "At the end of your rental, you'll receive a link to your private online gallery, filled with curated, cinematic memories to cherish and share forever.",
    illustration: "https://pratham-public-bucket.s3.us-east-1.amazonaws.com/1755564324123~2.jpg"
  }
];

const MagicBehindMoments: React.FC = () => {
  return (
    <section className="magic-behind-moments">
      <div className="magic-container">
        <h2 className="magic-heading">Magic Behind the Moments</h2>
        
        <div className="process-steps">
          {processSteps.map((step, index) => (
            <div 
              key={step.stepNumber}
              className={`process-row ${index % 2 === 1 ? 'reverse' : ''}`}
            >
              <div className="step-number-bg">{step.stepNumber}</div>
              
              <div className="step-illustration">
                <div className="illustration-placeholder">
                  {step.illustration.startsWith('http') ? (
                    <img 
                      src={step.illustration} 
                      alt={step.title}
                      className="illustration-image"
                    />
                  ) : (
                    <span className="illustration-icon">{step.illustration}</span>
                  )}
                </div>
              </div>
              
              <div className="step-content">
                <div className="step-number">{step.stepNumber}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MagicBehindMoments;